import { ItemTypeEnum } from '../../enum/item-type.enum';
import { ItemTask } from './item-task';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateItemWebConsoleCommand {
  ItemId: string;
  Estimator: string;
  ItemType: ItemTypeEnum;
  QuoteNumber: string;
  ContractId: string;
  QuoteId: string;
  AllocatedHours: number;
  ItemName: string;
  ItemNumber: string;
  ScaffoldIds: string[];
  Tasks: ItemTask[];
}


